import { useEffect } from 'react';
import type { RefObject } from 'react';

export default function useAnchorScroll(
  containerRef: RefObject<HTMLElement | null>,
  headerSelector?: string,
) {
  useEffect(() => {
    const targetId = window.location.hash.replace('#', '');
    if (!targetId) return;

    const header = headerSelector
      ? document.querySelector<HTMLElement>(headerSelector)
      : null;

    const scrollport = document.scrollingElement as HTMLElement | null;

    if (header && scrollport) {
      scrollport.style.scrollPaddingTop = `${header.offsetHeight}px`;
    }

    document
      .getElementById(targetId)
      ?.scrollIntoView({ behavior: 'smooth', block: 'start' });

    return () => {
      if (header && scrollport) {
        scrollport.style.scrollPaddingTop = '';
      }
    };
  }, [containerRef, headerSelector]);

  return;
}
